import { render, staticRenderFns } from "./ManageItemId.vue?vue&type=template&id=2d02db5e&scoped=true"
import script from "./ManageItemId.vue?vue&type=script&lang=js"
export * from "./ManageItemId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d02db5e",
  null
  
)

export default component.exports